import { Component, Input } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, UrlSegment } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Title } from "@angular/platform-browser";

declare let _: any;

@Component({
    selector: 'page-title',
    templateUrl: './page-title.html',
    styleUrls: ['./page-title.scss'],
    standalone: false
})

export class PageTitleComponent {
    @Input('document-title-only') documentTitleOnly: boolean = false;
    @Input() showShareButtons: boolean = true;

    readonly HOMEPAGE_TITLE = 'Homepage';

    public controller: string = '';
    public view: string = '';

    constructor(private router: Router,
                private translateSvc: TranslateService,
                private titleSvc: Title) {
        const self = this;

        // router.events.subscribe((val) => {
        //     if (val instanceof NavigationStart) {
        //         titleSvc.setTitle(translateSvc.instant('Loading'));
        //     }
        //     else if (val instanceof NavigationEnd) {
        //         const url = new UrlSegment(val.url, null);
        //         self._setPageTitle(url);
        //     }
        // });

    }

    protected _setPageTitle(url: UrlSegment): void {
        this.controller = '';
        this.view = '';

        const path = decodeURIComponent(url.path.replace(/^\//, ""));
        const list = path.split('/') || [];
        this.controller = !_.isEmpty(list[0])
            ? _.startCase(list[0]).replace(/-/gi, ' ')
            : this.HOMEPAGE_TITLE;

        this.view = !_.isEmpty(list[list.length-1])
            ? _.startCase(list[list.length-1]).replace(/-/gi, ' ')
            : this.controller;

        // document title
        this.titleSvc.setTitle(this.translateSvc.instant(this.view));
    }

}
